var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H16",
    stroke: "#2C2D3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.25C14.5858 7.25 14.25 7.58579 14.25 8C14.25 8.41421 14.5858 8.75 15 8.75V7.25ZM15 15.25C14.5858 15.25 14.25 15.5858 14.25 16C14.25 16.4142 14.5858 16.75 15 16.75V15.25ZM15 8.75H17V7.25H15V8.75ZM17 15.25H15V16.75H17V15.25ZM20.25 12C20.25 13.7949 18.7949 15.25 17 15.25V16.75C19.6234 16.75 21.75 14.6234 21.75 12H20.25ZM17 8.75C18.7949 8.75 20.25 10.2051 20.25 12H21.75C21.75 9.37665 19.6234 7.25 17 7.25V8.75Z",
    fill: "#2C2D3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.75C9.41421 8.75 9.75 8.41421 9.75 8C9.75 7.58579 9.41421 7.25 9 7.25V8.75ZM9 16.75C9.41421 16.75 9.75 16.4142 9.75 16C9.75 15.5858 9.41421 15.25 9 15.25V16.75ZM9 7.25H7V8.75H9V7.25ZM7 16.75H9V15.25H7V16.75ZM2.25 12C2.25 14.6234 4.37665 16.75 7 16.75V15.25C5.20507 15.25 3.75 13.7949 3.75 12H2.25ZM7 7.25C4.37665 7.25 2.25 9.37665 2.25 12H3.75C3.75 10.2051 5.20507 8.75 7 8.75V7.25Z",
    fill: "#2C2D3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChain);
export default __webpack_public_path__ + "static/media/icon-chain.932c79c336ece551bb95505db4425809.svg";
export { ForwardRef as ReactComponent };